<style>

h3{
  text-align: center;
}

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(0,0,0,0.2);
}

.space{
  margin: 20px;
}

.optional{
  text-align: center;
  color: white;
  font-size: 15px;
  margin: auto;
  margin-top: 10px;
  max-width: 220px;
}

.list{
  position: fixed;
  top: 160px;
  left: 0;
  right: 0;
  bottom: 150px;
  z-index: 2;
  overflow-y: auto;
}

.item{
  display: grid;
  grid-template-columns: 40px auto;
  color: white;
  margin: 10px 40px 0 40px;
  padding: 10px 0;
}
.check{
  grid-column: 1;
  text-align: center;
}
.text{
  grid-column: 2;
}

.small-margin{
  margin-top: 10px;
  color: white;
}
.info-margin{
  margin: 10px;
  color: #777;
  font-size: 17px;
}
.large-margin{
  margin-top: 30px;
}

p{
  color: white;
  font-size: 15px;
}

.search-results{
  background-color: rgba(0,0,0,0.2);
  height: 200px;
  overflow-y: auto;
  color: white;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.search-item{
  margin: 10px;
}
</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>Location Info</h3>
<div class="optional">We need your location to find events and people near you</div>

<RadioList list="{locationTypes}" bind:selected="{locationSelected}" on:updated="{radioListUpdated}"></RadioList>

{#if locationSelected == "Use GPS (Street Level)"}
  <div class="large-margin">
    <button on:click="{ () => capture('street') }">Update My Location</button>
  </div>
{/if}

{#if locationSelected == "Use GPS (City Level)"}
  <div class="large-margin">
    <button on:click="{ () => capture('city') }">Update My Location</button>
  </div>
{/if}


{#if locationSelected == "Enter City Name"}
  <p>This might not work well for you depending on how far away you are from the city center...</p>
  <div class="small-margin">
    <ValidInput bind:value="{city}" valid="{found}" style="border-top-left-radius: 10px; border-top-right-radius: 10px; border-bottom: 2px gray solid; background-color: rgba(0,0,0,0.2);" placeholder="Search for city" on:changed="{cityChanged}"></ValidInput>
  </div>
  
  <div class="search-results">
    {#if searchItems.length}
      {#each searchItems as item}
        <div class="search-item" on:click="{ () => citySelected(item) }">{item.n}</div>
      {/each}
    {:else if found}
      <div><!-- empty on purpose --></div>
    {:else if noSearch}
      <div class="info-margin">Only cities in Los Angeles and Orange County, USA are supported at this time.</div>
    {:else if city == ""}
      <div class="info-margin">City can't be empty.</div>
      <div class="info-margin">Only cities in Los Angeles and Orange County, USA are supported at this time.</div>
    {:else}
      <div class="info-margin">Nothing found...</div>
    {/if}
  </div>
  
{/if}

{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";
import Cities from "../../helpers/Cities.js";
import {randoGPS} from "../../helpers/Geo.js";

import RadioList from "../../components/RadioList.svelte";
import ValidInput from "../../components/ValidInput.svelte";

export let show = false;
export let me = null;

let locationType = -1;
let locationTypes = [
  "Use GPS (Street Level)",
  "Use GPS (City Level)",
  "Enter City Name",
];
let locationSelected = "Use GPS (Street Level)";
// let locationSelected = "Enter City Name";

let city = "";
let searchItems = [];
let found = false;
let noSearch = true;

let lat = 0;
let long = 0;


$:{
  if (me) set();
}


function set() {
  lat = me.lat;
  long = me.long;
}



let watchID = null;
function capture(accuracy) {
  
  const options = {
    enableHighAccuracy: accuracy == 'street' ? true : false,
    maximumAge: 30000,
    timeout: 27000
  };
  
  if('geolocation' in navigator) {
    watchID = navigator.geolocation.watchPosition(captureSuccess, captureFail, options);
  } else {
    // error
  }
}


let captures = 0;
function captureSuccess(position) {
  // console.log("position:", position);
  lat = position.coords.latitude;
  long = position.coords.longitude;
  
  check();
  
  captures++;
  if (captures > 2) {
    navigator.geolocation.clearWatch(watchID);
  }
}


function captureFail() {
  console.log("gps capture failed");
}


function cityChanged(e) {
  found = false;
  noSearch = false;
  searchItems = [];
  
  if (city != "") {
    let searchFor = city.toLowerCase();
    
    for (let i in Cities.gps) {
      if (i.includes(searchFor) == true) {
        searchItems.push(Cities.gps[i]);
      }
    }
  }
}


function citySelected(item) {
  found = true;
  searchItems = [];
  lat = item.lt;
  long = item.lg;
  city = item.n;
  check();
}


function radioListUpdated(e) {
  // console.log("e.detail:", e.detail);
  if (e.detail.text == "Enter City Name") dispatch("expand");
  if (e.detail.text != "Enter City Name") dispatch("shorten");
}


function check() {
  try {
    if (lat == 0 & long == 0) throw "no location selected";
  } catch (e) {
    console.log("error:", e);
  }
}


export const save = async () => {
  if (lat != me.lat || long != me.long) {
    // get a slightly randomized gps location back
    let {tlat, tlong} = randoGPS(lat, long);
    me.lat = tlat;
    me.long = tlong;
    await profile.updateMe( { updateShare: true } );
  }
}


</script>